export const createAnnouncement = `mutation createAnnouncement($input: CreateAnnouncementInput!) {
    createAnnouncement(input: $input) {
    id
    companyId
    title
    content
    dateCreated
    hide
    userGroups
    thumbnail {
      bucket
      key
      region
    }
    displayGroupSelect
    tags
    pinned
    author
    thumbnailSignedUrl
    publishAt
    expireAt
    viewCount
    updatedAt
    }
  }
  `;
